import type { MapSource } from '../map';
import type { ThingKind } from '../things';

/** One prop of the packs', so the client keeps its things' life (a blast's smoke a fluid): a cabbage out of the shot. */
const KINDS: ThingKind[] = [{ key: 'Props - Cabbage 01', material: 'wood', shapes: [] }];

/**
 * The proving ground (`?royale&map=proving-ground`, a dev map): a lawn in the village packs with one training dummy in
 * its middle, nothing else in sight: a Game Juice 101 short's prototyping level (`?scene=bazooka-juice`).
 */
export const PROVING_GROUND: MapSource = {
  id: 'proving-ground',
  name: 'Proving Ground',
  style: 'village',
  rows: `
    ############################################
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #.....................S....................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    #.................P.......P................#
    #..........................................#
    #..........................................#
    #..........................................#
    #.................P.......P................#
    #..........................................#
    #..........................................#
    #..........................................#
    #..........................................#
    ############################################
  `,
  kinds: KINDS,
  things: [[0, 72, 72]],
};
